
















































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  Fornecedor,
  FornecedoresService,
} from "@/services/fornecedores.service";

/**
 * Select de fornecedor global exibido como arvore de dois niveis: cada holding aparece
 * desabilitada, apenas para mostrar a quem as marcas indentadas abaixo dela pertencem.
 * Holding nao pode ser dona de catalogo nem de produto, e quem garante isso e a
 * validacao no servidor (BLL.Catalogo) -- aqui ela e so informativa.
 */
@Component
export default class SelectFornecedor extends Vue {
  @Prop() value!: string | null;
  @Prop({ default: "Fornecedor" }) label!: string;
  @Prop() rules!: unknown[];
  @Prop() disabled!: boolean;
  @Prop({ default: true }) somenteAtivos!: boolean;

  fornecedores: Fornecedor[] = [];
  loading = false;

  async created() {
    this.loading = true;
    try {
      this.fornecedores = await FornecedoresService.listarFornecedoresGlobais(
        "",
        this.somenteAtivos
      );
    } finally {
      this.loading = false;
    }
  }

  get itens(): Fornecedor[] {
    const holdings = this.fornecedores.filter((x) => x.ehHolding);
    const filhosDe = (idHolding: string) =>
      this.fornecedores.filter(
        (x) => !x.ehHolding && x.idFornecedorHolding === idHolding
      );

    const itens: Fornecedor[] = [];
    holdings.forEach((holding) => {
      itens.push(holding, ...filhosDe(holding.idFornecedor));
    });
    this.fornecedores
      .filter((x) => !x.ehHolding && !x.idFornecedorHolding)
      .forEach((x) => itens.push(x));

    return itens;
  }

  get model(): string | null {
    return this.value;
  }

  set model(val: string | null) {
    this.$emit("input", val);
  }
}
